
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.067 11.764a.449.449 0 000 .472.591.591 0 00.035.052.5.5 0 00.149.136c.01.006.015.018.025.023l7 3.5A.5.5 0 008 15.5v-3h15.5a.5.5 0 000-1H8v-3a.5.5 0 00-.237-.425A.5.5 0 007.5 8a.508.508 0 00-.224.053l-7 3.5c-.01 0-.015.017-.025.023a.488.488 0 00-.149.137.459.459 0 00-.035.051z"}})])
          )
        }
      }
    